<span
  class="currency-icon"
  [class.with-network]="networkIcon"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="size * 0.4"
>
  <img
    class="asset-icon"
    [src]="assetIcon"
    [alt]="label"
    [style.width.px]="size"
    [style.height.px]="size"
    (error)="assetIconMissing = true"
  />
  @if (networkIcon) {
    <img
      class="network-badge"
      [src]="networkIcon"
      alt=""
      [style.width.px]="badgeSize"
      [style.height.px]="badgeSize"
      (error)="networkIconMissing = true"
    />
  }
</span>
